import * as styles from "./FilterChip.css";

import { Icon } from "@frontend/components/atoms/Icon";
import { useLingui } from "@lingui/react";

import type { FilterToken } from "../dsl/types";
import { commandPaletteLabels } from "../i18n/labels";
import { getResultTypeDefinition } from "../results/registry";

export type FilterChipProps = {
  token: FilterToken;
  onRemove: () => void;
};

export function FilterChip({ token, onRemove }: FilterChipProps) {
  const { _ } = useLingui();

  const definition =
    "type" === token.key ? getResultTypeDefinition(token.value) : undefined;

  const valueLabel = definition ? _(definition.label) : token.value;

  return (
    <span className={styles.chip}>
      <span className={styles.key}>{token.key}:</span>
      <span className={styles.value}>{valueLabel}</span>
      <button
        type="button"
        className={styles.remove}
        onClick={onRemove}
        aria-label={`${_(commandPaletteLabels.removeFilter)}: ${token.key}:${token.value}`}
      >
        <Icon name="X" size={12} />
      </button>
    </span>
  );
}
